import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Data_getInstance1y32uagt6q69y as Data_getInstance } from './adapter/DeleteSecretMutation_ResponseAdapter.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DeleteSecretMutation_VariablesAdapter_instance2vmau8r8as45k as DeleteSecretMutation_VariablesAdapter_instance } from './adapter/DeleteSecretMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(deleteSecret) {
        this.t6e_1 = deleteSecret;
      }
      toString() {
        return 'Data(deleteSecret=' + this.t6e_1 + ')';
      }
      hashCode() {
        return this.t6e_1 == null ? 0 : getBooleanHashCode(this.t6e_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.t6e_1 == other.t6e_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.u6e_1 = '5a55c69595e1569210aeaa4dfc459e9c525775865fce9c5a8fbfdc346149c2c8';
        this.v6e_1 = 'deleteSecret';
      }
      u6d() {
        return 'mutation deleteSecret($input: DeleteSecretInput!) { deleteSecret(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var DeleteSecretMutationClass;
function DeleteSecretMutation() {
  if (DeleteSecretMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.w6e_1 = input;
      }
      w6d() {
        return '5a55c69595e1569210aeaa4dfc459e9c525775865fce9c5a8fbfdc346149c2c8';
      }
      operationId() {
        return this.w6d();
      }
      v47() {
        return Companion_instance.u6d();
      }
      x6d() {
        return 'deleteSecret';
      }
      operationName() {
        return this.x6d();
      }
      p46(writer, customScalarAdapters, withDefaultValues) {
        DeleteSecretMutation_VariablesAdapter_instance.x6e(writer, this, customScalarAdapters, withDefaultValues);
      }
      o46() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'DeleteSecretMutation(input=' + this.w6e_1.toString() + ')';
      }
      hashCode() {
        return this.w6e_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeleteSecretMutation()))
          return false;
        if (!this.w6e_1.equals(other.w6e_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeleteSecretMutation', VOID, VOID, [Mutation()]);
    DeleteSecretMutationClass = $;
  }
  return DeleteSecretMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Data as Data19yd1q1ikzzyl,
  DeleteSecretMutation as DeleteSecretMutation2wndasm4ltzuw,
};
//endregion

//# sourceMappingURL=DeleteSecretMutation.mjs.map
